export enum TeamStatus {
  INACTIVE = 0,
  ACTIVE,
}
